import React from 'react';
import { isEmpty } from 'lodash';
import CreativeDetails from './components/CreativeDetails';
import CampaignDetailsCreativeLoader from '../../../../../../core/components/campaigns/campaigndetails/creatives/CampaignDetailsCreativeLoader';
import EntityCardSkeleton from '../EntityCardSkeleton';

const Creatives = ({ colStyle, selectedCampaign, chartsLoading, creativeData }) => {
  if (chartsLoading) return <EntityCardSkeleton />;
  if (isEmpty(creativeData)) return null;

  return (
    <CampaignDetailsCreativeLoader
      creativeAdProviderIds={creativeData.map((row) => String(row.id))}
      creativeDataReport={creativeData}
    >
      <CreativeDetails colStyle={colStyle} selectedCampaign={selectedCampaign} />
    </CampaignDetailsCreativeLoader>
  );
};

export default Creatives;
